module.exports = __webpack_public_path__ + "assets/img/gz.b7982d46.jpg";